import { useState, useEffect } from "react";
import UpdateProductForm from "../components/UpdateProductForm";

const URL = process.env.REACT_APP_API_URL;

export default function UpdateProduct({
  selectedProducts,
  onUpdate,
  onClose,
  productTypes,
  empresaRubro,
}) {
  const [productData, setProductData] = useState({ 
    name: "", 
    type: "", 
    price: "", 
  });
  
  const isSingleProduct = selectedProducts.length === 1;

  const [editMethod, setEditMethod] = useState(false);
  const [sellMethod, setSellMethod] = useState("Unidad");
  const [quantityReference, setQuantityReference] = useState(1);
  const [unit, setUnit] = useState("gr");

  useEffect(() => {
    if (selectedProducts.length === 1 && productTypes.length > 0) {
      const [product] = selectedProducts;
      const typeMatch = productTypes.find(
        (t) => t.type === product.product_type?.type
      );

      setProductData({
        name: product.name,
        type: typeMatch?.id || "", // si no encuentra tipo deja vacio
        price: product.price,
      });
      setSellMethod(product.sell_method || "Unidad");
      setQuantityReference(product.quantity_reference || 1);
      setUnit(product.quantity_reference >= 1000 ? "kg" : "gr");
    } else {
      setProductData(prev => ({ ...prev, price: "" }));
    }
  }, [selectedProducts, productTypes]);
  
  // TODO setear de alguna manera el setPriceIncrease

  const handleReferenceChange = (e) => {
    const input = Number(e.target.value);
    setQuantityReference(unit === "kg" ? input * 1000 : input);
  };
  
  const handleUnitChange = (e) => {
    const newUnit = e.target.value;
    setUnit(newUnit);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    if (isSingleProduct) {
      const productId = selectedProducts[0].id;
      fetch(`${URL}/api/products/${productId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: productData.name,
          price: Number(productData.price),
          type_id: productData.type,
          ...(editMethod && {
            sell_method: sellMethod,
            quantity_reference:
              sellMethod === "Unidad" ? 1 : Number(quantityReference),
          }),
      })
      })
      .then(() => {
        onUpdate();
        onClose();
      })
      .catch((error) => console.error("Error updating product:", error));
    } else {
      const payload = {
        product_ids: selectedProducts.map(p => p.id),
        percentage: parseFloat(productData.price),
      };
  
      console.log("Payload enviado al backend:", payload);
      // Varios productos: aplicar aumento
      fetch(`${URL}/api/products/price-increase/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          percentage: parseFloat(productData.price),
          products: selectedProducts.map((product) => product.id),
        }),
      })
      .then(() => {
        onUpdate();
        onClose();
      })
      .catch((error) => console.error("Error applying price increase:", error));
    }    
  };

  return (
    <UpdateProductForm
      productData={productData}
      isSingleProduct={isSingleProduct}
      selectedCount={selectedProducts.length}
      productTypes={productTypes}
      editMethod={editMethod}
      setEditMethod={setEditMethod}
      sellMethod={sellMethod}
      setSellMethod={setSellMethod}
      quantityReference={quantityReference} 
      setQuantityReference={setQuantityReference}
      unit={unit}
      setUnit={setUnit}
      handleReferenceChange={handleReferenceChange}
      handleUnitChange={handleUnitChange}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      empresaRubro={empresaRubro}
    />
  )

}
